import { CustomizationPropertiesController } from './customization-properties.controller'

function customizationProperties () {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      data: '<',
      formProperties: '=',
      tabsLoadingData: '=',
      warningCustomizable: '<',
      errors: '<',
      features: '<',
      openUpgradeCompanyPlanDialog: '&'
    },
    templateUrl: '/arts/directives/customization-properties/customization-properties-directive.html?$$REVISION$$',
    controller: CustomizationPropertiesController
  }
}

export { customizationProperties }
